import urlJoin from 'url-join';
import hasUrlOrigin from '../../utils/helpers/has-url-origin';
import site from '../../site';

const addBaseHref = (path) => {
  if (hasUrlOrigin(path)) return path;
  return urlJoin(site.accessors.getAssetsUrl(), path.trim());
};

export default addBaseHref;
